/**
 * Generates a normalized `data-test-id` string by slugifying the input text and optional suffixes.
 *
 * - Converts all parts to lowercase.
 * - Replaces non-alphanumeric characters with dashes.
 * - Joins segments with `--` for clarity and consistency.
 *
 * @param {string | false} text - The base text to include in the test ID. If `false`, defaults to `'noname'`.
 * @param {string} [suffix] - An optional suffix to append, normalized similarly.
 * @param {string} [extraSuffix] - An optional additional suffix to append after `suffix`, normalized.
 * @returns {string} The generated `data-test-id` string in the format `base--suffix--extraSuffix`.
 *
 * @example
 * generateDataTestId('Submit Button', 'Primary') // 'submit-button--primary'
 * generateDataTestId(false, 'Fallback', 'State') // 'noname--fallback--state'
 */

export function generateDataTestId(text: string | false, suffix?: string, extraSuffix?: string): string {
  const baseId = text ? text.toLowerCase().replaceAll(/[^a-z0-9]+/g, '-') : 'noname'
  suffix = (String(suffix ?? '')).toLowerCase().replaceAll(/[^a-z0-9]+/g, '-')
  extraSuffix = String((extraSuffix ?? '')).toLowerCase().replaceAll(/[^a-z0-9]+/g, '-')
  const parts = [baseId, suffix, extraSuffix].filter(Boolean)
  return parts.join('--')
}
